import { Checkout as CheckoutComponent } from 'components/Checkout/Checkout';
import { NOOP } from 'constants/actions';
import { useTheme } from 'hooks/useTheme';
import { DisplayMode } from 'models';
import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';

const DrawerLayout = lazy(() =>
  import('components/DrawerLayout/DrawerLayout').then(module => ({
    default: module.DrawerLayout,
  })),
);

const InlineLayout = lazy(() =>
  import('components/InlineLayout/InlineLayout').then(module => ({
    default: module.InlineLayout,
  })),
);

export const LayoutRouter = ({ onRestart = NOOP, ...rest }) => {
  const theme = useTheme();
  const displayMode = theme?.mode;

  if (displayMode === DisplayMode.Drawer) {
    return (
      <Suspense fallback={<div />}>
        <DrawerLayout onRestart={onRestart} {...rest} />
      </Suspense>
    );
  }

  if (displayMode === DisplayMode.Inline) {
    return (
      <Suspense fallback={<div />}>
        <InlineLayout onRestart={onRestart} {...rest} />
      </Suspense>
    );
  }

  return <CheckoutComponent onRestart={onRestart} {...rest} />;
};

LayoutRouter.propTypes = {
  onRestart: PropTypes.func,
};
